import {type LeaderboardRowData} from '../../../../shared/leaderboard_data/LeaderboardInterfaces.ts'
import {createTDIn} from '../ui_utils/DomUtils.ts'
import {UILeaderboardBaseTableRowView} from './UILeaderboardBaseTableRowView.ts'

export class UILeaderboardTableRowViewRanked extends UILeaderboardBaseTableRowView {
    readonly tdMMR: HTMLTableCellElement
    readonly tdWinRate: HTMLTableCellElement | undefined
    readonly tdTotalGamesPlayed: HTMLTableCellElement | undefined

    constructor(container: HTMLElement, rowData: LeaderboardRowData, index: number, onLeaderboardUrlChange: (leaderboardUrl: string) => void) {
        super(container, rowData, index, onLeaderboardUrlChange)

        const tableRowID = rowData.myData ? 'my_leaderboard_cell' : 'leaderboard_cell'

        this.tdMMR = createTDIn(this.tableRow, tableRowID)
        this.tdWinRate = createTDIn(this.tableRow, `${tableRowID} hide_on_narrow_screens`)
        this.tdTotalGamesPlayed = createTDIn(this.tableRow, `${tableRowID} hide_on_narrow_screens`)

        this.update(rowData)
    }

    update(rowData: LeaderboardRowData) {
        super.update(rowData)

        this.tdMMR.innerText = String(rowData.skillRating)
        if(this.tdWinRate) this.tdWinRate.innerText = `${rowData.winRate.toFixed(1)}%`
        if(this.tdTotalGamesPlayed) this.tdTotalGamesPlayed.innerText = '' + rowData.totalGamesPlayed
    }
}
